import { Route } from "@angular/router";
import { authenticatedGuard } from "./guards/authenticated.guard";
import { capturePlanGuard } from "./guards/capture-plan.guard";
import { onboardedAlreadyGuard } from "./guards/onboarded_already.guard";
import { subscribedGuard } from "./guards/subscribed.guard";
import { unauthenticatedGuard } from "./guards/unauthenticated.guard";
import { ForgotPasswordPageComponent } from "./pages/forgot-password/forgot-password.component";
import { OnboardingPageComponent } from "./pages/onboarding/onboarding.component";
import { CancelledPageComponent } from "./pages/payment/cancelled/cancelled.component";
import { SuccessPageComponent } from "./pages/payment/success/success.component";
import { ResetPasswordPageComponent } from "./pages/reset-password/reset-password.component";
import { SigninPageComponent } from "./pages/signin/signin.component";
import { SignupPageComponent } from "./pages/signup/signup.component";
import { SubscribePageComponent } from "./pages/subscribe/subscribe.component";

export const subscriptionRoutes: Route[] = [
  {
    path: "signin",
    component: SigninPageComponent,
    canActivate: [capturePlanGuard, unauthenticatedGuard],
  },
  {
    path: "signup",
    component: SignupPageComponent,
    canActivate: [capturePlanGuard, unauthenticatedGuard],
  },
  {
    path: "forgot-password",
    component: ForgotPasswordPageComponent,
    canActivate: [unauthenticatedGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordPageComponent,
  },
  {
    path: "subscribe",
    component: SubscribePageComponent,
    canActivate: [capturePlanGuard, authenticatedGuard],
  },
  {
    path: "onboarding",
    component: OnboardingPageComponent,
    canActivate: [authenticatedGuard, subscribedGuard, onboardedAlreadyGuard],
  },
  {
    path: "payment/success",
    component: SuccessPageComponent,
    canActivate: [authenticatedGuard],
  },
  {
    path: "payment/cancelled",
    component: CancelledPageComponent,
    canActivate: [authenticatedGuard],
  },
  // Org-owned account awaiting admin classification. Reached via
  // orgPendingGuard redirect; deliberately outside the guarded app shell.
  {
    path: "waiting-for-school",
    loadComponent: () =>
      import("./pages/waiting-for-school/waiting-for-school.component").then(
        (m) => m.WaitingForSchoolComponent,
      ),
    canActivate: [authenticatedGuard],
  },
];
